import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
const VisitReportDetailsPage = () => (<Box sx={{ p: 3 }}><Card><CardContent><Typography variant="h4">Visit Report Details</Typography><Typography>Coming soon</Typography></CardContent></Card></Box>);
export default VisitReportDetailsPage;